
import { Component, Input, OnInit, } from '@angular/core';
import { DomSanitizer, SafeHtml} from '@angular/platform-browser';
@Component({
  selector: 'cbic-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit {
  youtubeVideoElement:any;
  mediaUrlPrefix = 'content/anotherfile/media/';
  mediaUrl: any
  @Input() path?: string;
  @Input() type?: string;
  @Input() modelRef: any;
  youtube = "Youtube.com";
  youtubestatus = "Video";
  drive = "google.com";
  http="http";
  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    console.log(this.path, this.type);
    let urlPrefix = this.mediaUrlPrefix;
    if (this.type === 'Video' && (this.path!.toLowerCase().includes(this.youtube.toLowerCase()) || this.path!.toLowerCase().includes(this.drive.toLowerCase()) ||  this.path!.toLowerCase().includes(this.http.toLowerCase()))) {
      this.youtubestatus = "Youtube";
      urlPrefix = "";
      // this.youtubeVideoElement = `
      //   <iframe src=" ${this.path?.replace("watch","embed")}" width="100%" 
      //     height="200" scrolling="no" style="overflow:hidden;" frameborder="0"
      //     allowfullscreen ng-show="showvideo"></iframe>\
      //   `;

        window.open(this.path, '_blank');
        this.modelRef.dismiss("close");
    }
   

    if(!this.path!.toLowerCase().startsWith(this.mediaUrlPrefix)){
      this.mediaUrl = `${urlPrefix}${this.path}`;
    }else{
      this.mediaUrl = this.path;
    }
  }

  getVideoElement() : SafeHtml{
    return this.sanitizer.bypassSecurityTrustHtml(this.youtubeVideoElement);
  }

  isImage(): boolean{
    return this.type === 'image';
  }
  isVideo(): boolean{
    return this.type === 'Video';
  }
  isAudio(): boolean{
    return this.type === 'Audio';
  }
}
